/*
 * Handles all the search requests for topics.
 * Defines a search results group, which is an extension of a topic group.  We use this model to allow
 * search results to mimic a topic group so we can reuse the topicsList module to show them.
 */

define([
  "jquery",
  "configuration/properties",
  "messaging/messenger",
  "modules/contentsSplit/contents/contentsModel",
], function ($, Properties, Messenger, ContentsModel) {
  var ContentsSearchModule = {};

  //Topic search results model extends the topic group model so it can be used in the topicsList module
  ContentsSearchModule.contentSearchResults = ContentsModel.contentGroup.extend({
    defaults: {
      groupId: -1,
      name: "",
      description: "",
      contentAwarenessOn: false,
    },
    contents: function () {
      if (!this.contentsCol) {
        this.contentsCol = new ContentsModel.contents();
        //pass modifiedCol or ignoredCol boolean parameter to collection so that models in
        //the collection can find out whether they are in a list of modified or ignored content
        this.contentsCol.modifiedCol = this.get("modifiedCol");
        this.contentsCol.ignoredCol = this.get("ignoredCol");
        this.contentsCol.url = this.get("searchUrl"); //use the search url provided during model creation
        this.contentsCol.fetch();
      }
      return this.contentsCol;
    },
  });

  Messenger.reqres.setHandler(
    "search:content:by:mapping:name",
    function (name) {
      var kbId = Messenger.reqres.request("active:kb");
      var searchUrl = `${Properties.rootURL}/${kbId}/mappings/nameOnly?name=${encodeURIComponent(
        name,
      )}`;
      //create a topicSearchResults model and assign it a search url
      var searchTitle = $.t("topics.search.searchResults", { criteria: name.escapeHtml() });
      var returnObj = new ContentsSearchModule.contentSearchResults({
        searchUrl: searchUrl,
        name: searchTitle,
      });
      return returnObj;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "search:content:by:url:string",
    function (urlString) {
      var kbId = Messenger.reqres.request("active:kb");
      var searchUrl = `${Properties.rootURL}/${kbId}/mappings/urlSearch?url=${encodeURIComponent(
        urlString,
      )}`;

      //create a topicSearchResults model and assign it a search url
      var searchTitle = $.t("topics.search.searchResults", { criteria: urlString.escapeHtml() });
      var returnObj = new ContentsSearchModule.contentSearchResults({
        searchUrl: searchUrl,
        name: searchTitle,
      });
      return returnObj;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "search:content:missing",
    function (localeId) {
      var kbId = Messenger.reqres.request("active:kb");
      var searchUrl = Properties.rootURL + "/" + kbId;
      //If localeId is 0, then search for all locales
      if (localeId === 0) {
        searchUrl += "/mappings/groups/0/missingRecursive";
      } else {
        searchUrl += "/mappings/groups/0/locale/" + localeId + "/missingRecursive";
      }
      //create a topicSearchResults model and assign it a search url
      var missingContent = $.t("contents.search.missingContent");
      var searchTitle = $.t("topics.search.searchResults", { criteria: missingContent });
      var returnObj = new ContentsSearchModule.contentSearchResults({
        searchUrl: searchUrl,
        name: searchTitle,
      });
      return returnObj;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "search:content:modified",
    function (localeId) {
      var kbId = Messenger.reqres.request("active:kb");
      var searchUrl = Properties.rootURL + "/" + kbId;
      //If localeId is 0, then search for all locales
      if (localeId === 0) {
        searchUrl += "/mappings/groups/0/modifiedRecursive";
      } else {
        searchUrl += "/mappings/groups/0/locale/" + localeId + "/modifiedRecursive";
      }
      //create a topicSearchResults model and assign it a search url
      var modifiedContent = $.t("contents.search.modifiedContent");
      var searchTitle = $.t("topics.search.searchResults", { criteria: modifiedContent });
      var returnObj = new ContentsSearchModule.contentSearchResults({
        searchUrl: searchUrl,
        name: searchTitle,
        modifiedCol: true, //attribute to let the models in the collection know that this is a modified content search
      });
      return returnObj;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "search:content:ignored",
    function () {
      var kbId = Messenger.reqres.request("active:kb");
      var searchUrl = Properties.rootURL + "/" + kbId + "/mappings/groups/0/ignoredRecursive";
      //create a topicSearchResults model and assign it a search url
      var ignoredContent = $.t("contents.search.ignoredContent");
      var searchTitle = $.t("topics.search.searchResults", { criteria: ignoredContent });
      var returnObj = new ContentsSearchModule.contentSearchResults({
        searchUrl: searchUrl,
        name: searchTitle,
        ignoredCol: true, //attribute to let the models in the collection know that this is an ignored content search
      });
      return returnObj;
    },
    this,
  );

  Messenger.reqres.setHandler(
    "search:content:new",
    function () {
      var kbId = Messenger.reqres.request("active:kb");
      var searchUrl = Properties.rootURL + "/" + kbId + "/mappings/groups/0/new";
      //create a topicSearchResults model and assign it a search url
      var newContent = $.t("contents.search.newContent");
      var searchTitle = $.t("topics.search.searchResults", { criteria: newContent });
      var returnObj = new ContentsSearchModule.contentSearchResults({
        searchUrl: searchUrl,
        name: searchTitle,
      });
      return returnObj;
    },
    this,
  );
});
